import { render, staticRenderFns } from "./BrandProducts.vue?vue&type=template&id=13936b42"
import script from "./BrandProducts.vue?vue&type=script&lang=js"
export * from "./BrandProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports